const basePath = '/health-tracker'
export {
    basePath
}